module.exports = __webpack_public_path__ + "static/gc-wireframes-552c2f590e1656b16024a82cafcade24.png";